import Vue from 'vue';

import ProjectInfo from './ProjectInfo.vue';

new Vue({
  ...ProjectInfo
}).$mount('#project-info');



// WEBPACK FOOTER //
// ./project_info/entry.js